export enum ParcelamentoSituacaoEnum {

  EM_PARCELAMENTO = "Em parcelamento",
  ENCERRADO_CONTRIBUINTE = "Encerrado a pedido do contribuinte",
  ENCERRADO_LIQUIDACAO = "Encerrado por liquidação",
  ENCERRADO_RECISAO = "Encerrado por rescisão"
}
